<!--
 * @Description: 
 * @Date: 2020-07-16 17:52:16
-->
<template>
  <div>
    <lBiTitle
      v-if="!itemIndex"
      title="报告内容"
      style="margin-top:60px;"
    ></lBiTitle>
    <div
      class="bi-item"
      v-if="images || echart || table || customComponents"
      :class="{ 'hide-title': header.hideHeader }"
      :style="header.hideNoMore ? { paddingBottom: '20px' } : {}"
    >
      <div class="bi-item-title" v-if="!header.hideHeader">
        <span style="margin-right:10px;">
          {{ `${header.index}`.padStart(2, 0) }}
        </span>
        <span>{{ header.title }}</span>
        <p v-if="[0, 1].includes(header.isMustFill)">
          <span>{{ header.isMustFill ? '必答题 ' : '非必答' }}</span>
        </p>
      </div>
      <p class="bi-item-tip" v-html="header.name"></p>
      <p class="bi-item-remark" v-if="header.remark" v-html="header.remark"></p>
      <template v-if="hasData">
        <div :class="{ 'map-layout': useMapLayout }">
          <component
            v-for="(item, index) in customComponents"
            :key="index"
            :is="item.com"
            v-bind="item.options"
          ></component>
          <Echarts
            v-for="(item, index) in echart"
            :key="index"
            :echartOption="item.echartOption"
            :echartStyle="item.echartStyle"
            :echartType="item.echartType"
          ></Echarts>
          <Table
            :useMapLayout="useMapLayout"
            :table="table"
            :normalTable="table && table.isNormal"
          ></Table>
          <Images :images="images"></Images>
        </div>
      </template>
      <p
        v-else-if="!header.hideNoMore"
        style="font-size: 15px;color: #666;margin-top: 20px;"
      >
        本项目月度暂未收集到有效数据
      </p>
    </div>
  </div>
</template>

<script>
import Echarts from './Echarts/Index';
import Table from './Table';
import Images from './Images';
import lBiTitle from './common/title';

export default {
  props: {
    itemIndex: {
      type: Number,
      default: 0
    },
    pkname: {
      type: String,
      default: ''
    },
    images: {
      type: [Array, Object],
      default() {
        return null;
      }
    },
    header: {
      type: Object,
      default() {
        return {
          index: '',
          title: '',
          name: ''
        };
      }
    },
    table: {
      type: Object,
      default() {
        return null;
        // {
        //   header: [
        //     { label: '地址1', prop: 'add1' },
        //     { label: '地址2', prop: 'add2' },
        //     { label: '地址3', prop: 'add3' }
        //   ],
        //   data: [
        //     { add1: '啊啊啊', add2: '啊啊啊2', add3: 'aaa3' },
        //     { add1: '啊啊啊', add2: '啊啊啊2', add3: 'aaa3' }
        //   ],
        //   finalDataCount: 0
        // };
      }
    },
    echart: {
      type: [Array, Object],
      default() {
        return null;
      }
    },
    customComponents: {
      type: [Array, Object],
      default() {
        return null;
      }
    },
    useMapLayout: {
      type: Boolean,
      default: false
    }
  },
  watch: {},
  data() {
    return {};
  },
  components: {
    Echarts,
    Table,
    Images,
    lBiTitle
  },
  computed: {
    hasData() {
      let iLen = this.images ? this.images.length : 0;
      let eLen = 0;
      let cLen = 0;
      let tLen =
        this.table && this.table.finalDataCount ? this.table.finalDataCount : 0;
      try {
        // 判断echart配置是否有数据
        if (this.echart && this.echart.length) {
          this.echart.forEach(item => {
            if (item.echartOption.series && item.echartOption.series.length) {
              item.echartOption.series.forEach(item2 => {
                if (item2.data && item2.data.length) {
                  eLen = !this.allZero(item2.data, 'value');
                }
              });
            }
            if (
              item.echartOption.series0data &&
              item.echartOption.series0data.length
            ) {
              eLen = !this.allZero(item.echartOption.series0data, 'value');
            }
          });
        }
        // 判断自定义组件的配置是否有数据
        if (
          Array.isArray(this.customComponents) &&
          this.customComponents.length > 0
        ) {
          this.customComponents.forEach(item => {
            cLen = [17, 18].includes(item.options.type)
              ? 1
              : item.options.finalDataCount;
          });
        }
      } catch (err) {
        console.error(err);
      }
      return Boolean(cLen) || Boolean(iLen) || Boolean(tLen) || Boolean(eLen);
    }
  },
  methods: {
    allZero(arr, key) {
      return arr.every(i => {
        if (Object.prototype.toString.call(i) === '[object Object]') {
          if (Object.prototype.toString.call(i[key]) === '[object Array]') {
            return i[key].every(_i => _i == 0);
          }
          return i[key] == 0;
        } else {
          return i == 0;
        }
      });
    }
  },
  mounted() {},
  created() {},
  beforeDestroy() {}
};
</script>

<style scoped lang="scss">
@import '~@/styles/mixin.scss';

.bi-item {
  background: #fff;
  max-width: 1200px;
  border-radius: 4px;
  padding: 31px 16px 60px 21px;
  & + .bi-item {
    margin-top: 16px;
  }
  &-title {
    background: #f7faff;
    padding: 12px 80px 14px 25px;
    font-size: 16px;
    font-weight: 600;
    color: #333333;
    line-height: 1.4;
    position: relative;
    text-align: left;
    letter-spacing: 2px;
    p {
      position: absolute;
      right: 30px;
      top: 0;
      width: 54px;
      height: 34px;
      color: #fff;
      font-size: 14px;
      text-align: center;
      line-height: 26px;
      span {
        position: relative;
        z-index: 2;
      }
      &:after {
        content: ' ';
        position: absolute;
        width: 50%;
        height: 30px;
        bottom: 4px;
        left: 25%;
        background: #ffc512;
        border-bottom-left-radius: 30px;
        border-bottom-right-radius: 30px;
        transform: scaleX(2);
        z-index: 1;
      }
    }
  }
  &-tip {
    letter-spacing: 2px;
    font-size: 16px;
    font-weight: 600;
    color: #333333;
    line-height: 1.4;
    padding: 0 30px;
    padding-top: 41px;
    padding-bottom: 10px;
  }
  &-remark {
    padding: 0 30px;
    padding-bottom: 20px;
    font-size: 14px;
    color: #666;
  }
  &.hide-title {
    margin-top: 0;
    padding-top: 10px;
    .bi-item-tip {
      padding-top: 0;
    }
  }
  .map-layout {
    display: flex;
    justify-content: flex-end;
    position: relative;
    .ebox {
      margin-right: -55px;
    }
    .bi-table {
      position: absolute;
      left: 0;
      top: 60px;
    }
  }
}
</style>
